"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CERTIFICATION_OVERVIEW: 'https://academy.hubspot.com/certification-overview',
  CERTIFICATION: 'https://academy.hubspot.com/certification',
  DEVELOPERS: 'https://developers.hubspot.com/',
  FREE_TRIAL: 'https://offers.hubspot.com/free-trial',
  HUBSPOT_FREE: 'https://www.hubspot.com/products/get-started',
  HELP: 'https://help.hubspot.com/',
  HUBSPOT_LOGO: 'http://cdn1.hubspot.com/hub/53/images/12-12-12-homepage/HubSpot_Logo_2x.png',
  REVIEW_GUIDELINES: 'https://legal.hubspot.com/review-guidelines',
  TERMS_OF_SERVICE: 'https://legal.hubspot.com/terms-of-service',
  TERMS_OF_USE: 'https://legal.hubspot.com/directory-tou',
  USER_GUIDES: {
    GENERAL: 'https://academy.hubspot.com/user-guides',
    LANDING_PAGE: 'https://knowledge.hubspot.com/landing-page-user-guide-v2',
    BLOG: 'https://knowledge.hubspot.com/blog-user-guide-v2',
    EMAIL: 'https://knowledge.hubspot.com/email-user-guide-v2',
    WEBSITE: 'https://knowledge.hubspot.com/website-user-guide'
  }
};
exports.default = _default;
module.exports = exports.default;